import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { ResponseModelInterfaceStatic } from "../../response-model-interface";

@staticImplements<ResponseModelInterfaceStatic>()
export class Status
{
    public constructor(
        public code: number,
        public codeLit: string,
        public message: string,
        public description: string,
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): Status
    {
        return new this(
            Number.parseInt(elem.firstChildByTag("statusCode").value()),
            elem.firstChildByTag("statusCodeLit").value(),
            elem.firstChildByTagOrNull("message")?.textContent ?? "",
            elem.firstChildByTagOrNull("description")?.textContent ?? "",
        );
    }
}
